"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ssRouterContractAddress = exports.referralAddress = void 0;
exports.referralAddress = '0x90A48D5CF7343B08dA12E067680B4C6dbfE551Be';
exports.ssRouterContractAddress = '0x4aac17d48e4ccb4e1c53cafbe4934fee899009c4';
